import { IDirective, ITimeoutService } from "angular"
import { TransitionService } from "angular-ui-router"

export function ScrollToTopOnStateChangeDirective(
  $transitions: TransitionService,
  $timeout: ITimeoutService,
): IDirective {
  return {
    restrict: "A",
    link: () => {
      $transitions.onSuccess({}, () => {
        $timeout(() => {
          const body = document.body
          const html = document.documentElement

          // cache values
          const prevBodyOverflow = body.style.overflow
          const prevHtmlOverflow = html.style.overflow
          const prevBodyTransform = body.style.transform

          // force reflow + scroll reset
          body.style.overflow = "hidden"
          html.style.overflow = "hidden"
          body.style.transform = "translateY(0)"
          void body.offsetHeight // evaluate but do not use

          window.scrollTo(0, 0)

          requestAnimationFrame(() => {
            // restore values
            body.style.overflow = prevBodyOverflow
            html.style.overflow = prevHtmlOverflow
            body.style.transform = prevBodyTransform

            window.scrollTo(0, 0) // again, for stubborn iOS
          })
        }, 0)
      })
    },
  }
}

ScrollToTopOnStateChangeDirective.$inject = ["$transitions", "$timeout"]
